import { render, staticRenderFns } from "./PopDetailTable.vue?vue&type=template&id=458b252c&scoped=true&"
import script from "./PopDetailTable.vue?vue&type=script&lang=js&"
export * from "./PopDetailTable.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/table.css?vue&type=style&index=0&id=458b252c&prod&scoped=true&lang=css&"
import style1 from "./PopDetailTable.vue?vue&type=style&index=1&id=458b252c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458b252c",
  null
  
)

export default component.exports